import moment from "moment";

export const TODAY_MOMENT = moment()
export const TODAY = TODAY_MOMENT.format('YYYY-MM-DD')